<template>

	<!-- <div id="bottom">
		<div middle>
			<div logo><img :src="getLogoPath()"></div>

			<div link>
				<ul>
					<li @click="shop">{{$t("footer.shop")}}</li>
					<li @click="contact">{{$t("footer.contact")}}</li>
					<li @click="home">{{$t("footer.home")}}</li>
				</ul>
			</div>
		</div>

		<el-drawer title="AVKE云驱动" custom-class="avke" :visible.sync="avke" :modal="false" :show-close="false" :direction="direction">

			<p> {{$t("footer.avke_desc.t1")}}<el-link type="warning"  href="http://official.longeplay.cn" target="_blank">{{$t("footer.avke_desc.t2")}}</el-link>{{$t("footer.avke_desc.t3")}}</p>
			<p>{{$t("footer.avke_desc.t4")}}</p>
			<p>{{$t("footer.avke_desc.t5")}}</p>
			<p>{{$t("footer.avke_desc.t6")}}</p>
			
		</el-drawer>

	</div> -->

</template>

<script>

export default {
  name: 'driveF',
  data() {

    return {
		ThemeConf:null,
		direction: 'rtl',
		avke: false,

	}
  },
  methods: 
  {
	home()
	{
		window.location.reload();
	},
	//获取主题LOGO
	getLogoPath()
	{
		let imgUrl = require("../../../" + process.env.VUE_APP_THEMENAME + "/asserts/image/logo.png");   
		return imgUrl;
	},
	shop()
	{
		if(this.ThemeConf == null && this.ThemeConf.ShopUrl == "")
		{
			this.$message({message:'请配置商店链接',type: 'warning',center: true,offset:500});
			return;
		}

		window.open(this.ThemeConf.ShopUrl, '_blank');
		
	},
	contact()
	{
		if(this.ThemeConf == null && this.ThemeConf.HomeUrl == "")
		{
			this.$message({message:'请配置品牌官网链接',type: 'warning',center: true,offset:500});
			return;
		}

		window.open(this.ThemeConf.HomeUrl, '_blank');
	}
  }

}

</script>